export default __webpack_public_path__ + "static/media/hotelsolutions-logo.206f4192.png";